import { PortalSidebarWidth, TABLET_PORTRAIT_WIDTH } from '../../../../style/constants';

// Not the app's TABLET_LANDSCAPE_WIDTH (1590): the `tablet` breakpoint has always used 1280.
const TABLET_BREAKPOINT_WIDTH = 1280;

export const breakpoints = {
    tablet: `${TABLET_BREAKPOINT_WIDTH - PortalSidebarWidth}px`,
    portrait: `${TABLET_PORTRAIT_WIDTH - PortalSidebarWidth}px`
};
